// modmeta-db stand-in for the web build.
//
// The real modmeta-db keeps a LevelDB of mod metadata and queries remote
// meta servers to map a file hash -> mod info (used to auto-tag installed
// mods with name/category/Nexus ids). In the browser there's no LevelDB and
// the meta servers are CORS-blocked, so this is an empty database: lookups
// return no matches and the install proceeds without auto-tagging.
//
// Must expose a constructible `ModDB.create` because the renderer calls it at
// install time; an empty-object fuse-off would throw "undefined is not a
// function" and abort the install.
class ModDB {
    static create(_dbPath, _gameId, _servers, _log) {
        return Promise.resolve(new ModDB());
    }
    lookup() {
        return Promise.resolve([]);
    }
    getByReference() {
        return Promise.resolve([]);
    }
    getByKey() {
        return Promise.resolve([]);
    }
    insert() {
        return Promise.resolve();
    }
    setGameId() {
        return Promise.resolve();
    }
    addServer() {}
    updateServers() {}
    close() {
        return Promise.resolve();
    }
}

// genHash is sometimes imported from modmeta-db; the renderer mostly uses its
// own checksum util, but provide a no-op-ish fallback just in case.
function genHash() {
    return Promise.resolve({ md5sum: "", numBytes: 0 });
}

module.exports = { ModDB, genHash };
module.exports.default = module.exports;
